import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { Sidebar } from "./Sidebar";

export function Layout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const loc = useLocation();

  // 路由变化时自动收起移动端抽屉
  const close = () => setDrawerOpen(false);

  return (
    <div className={`app-shell ${drawerOpen ? "drawer-open" : ""}`}>
      {/* 移动端顶栏 */}
      <header className="topbar">
        <button className="topbar-burger" aria-label="菜单" onClick={() => setDrawerOpen((v) => !v)}>
          <span /><span /><span />
        </button>
        <div className="topbar-title">珂玺 · 资本</div>
      </header>

      <Sidebar onNavigate={close} key={loc.pathname.split("/")[1]} />

      {/* 抽屉遮罩 */}
      {drawerOpen && <div className="drawer-scrim" onClick={close} />}

      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
